const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    for (const node of mutation.addedNodes) {
      if (
        node.tagName === "STYLE" &&
        node.textContent.includes("button-loading")
      ) {
        console.warn("removed problematic ampersand classes");
        node.remove();
      }
    }
  }
});

observer.observe(document.documentElement, { childList: true, subtree: true });
